define('OutSystems/ReactView/createHistory',["require", "exports", "tslib", "history"], function (require, exports, tslib_1, history_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var createHistory = function (allowNavigation, screenLoader, historyFactory) {
        if (allowNavigation === void 0) { allowNavigation = function () { return true; }; }
        if (historyFactory === void 0) { historyFactory = function (options) { return (0, history_1.createBrowserHistory)(options); }; }
        var locationDataCache = {};
        var history = historyFactory({
            getUserConfirmation: function (key, callback) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var locationData, result, screenLoadPromise, error_1;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                locationData = locationDataCache[key];
                                result = false;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, 6, 7]);
                                if (!locationData) return [3, 4];
                                screenLoadPromise = screenLoader.load(locationData.location, locationData.action, history);
                                if (!screenLoadPromise) return [3, 3];
                                return [4, screenLoadPromise];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                result = true;
                                _a.label = 4;
                            case 4: return [3, 7];
                            case 5:
                                error_1 = _a.sent();
                                return [3, 7];
                            case 6:
                                delete locationDataCache[key];
                                return [7];
                            case 7:
                                callback(result);
                                return [2];
                        }
                    });
                });
            },
        });
        if (history.location && !history.location.state) {
            var initialLocation = tslib_1.__assign(tslib_1.__assign({}, history.location), { state: { age: 0 } });
            history.push(initialLocation);
        }
        history.block(function (nextLocation, action) {
            var _a;
            var key = (_a = nextLocation.key) !== null && _a !== void 0 ? _a : "";
            locationDataCache[key] = allowNavigation(history.location, nextLocation, action)
                ? { location: nextLocation, action: action }
                : null;
            return key;
        });
        return history;
    };
    exports.default = createHistory;
});
//# sourceMappingURL=createHistory.js.map;
